export const copyText = (text: string | null | undefined) => {
  if (text) {
    navigator.clipboard.writeText(text)
  }
}
